// extracted by mini-css-extract-plugin
module.exports = {"submitSaveAndSend":"_1HYAI5oVWe8Nt5EmqiTXm7 button success"};